import React, { useMemo } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { ErrorIcon, SuccessIcon } from "ui/icons";
import { FilterTabs } from "ui/tabs";
import { type FeatureComparisonRow, type FeatureDetails } from "./data";

export function ComparisonsTabs({ comparisons }: { comparisons: FeatureComparisonRow[] }) {
  const [hightouchFeatures, traditionalFeatures] = useMemo(() => {
    const hightouchFeatures: FeatureDetails[] = [];
    const traditionalFeatures: FeatureDetails[] = [];

    for (const comparison of comparisons) {
      hightouchFeatures.push(comparison.hightouch);
      traditionalFeatures.push(comparison.traditionalCdp);
    }

    return [hightouchFeatures, traditionalFeatures];
  }, [comparisons]);

  return (
    <FilterTabs
      justify="stretch"
      gap="bigger"
      tabs={[
        {
          label: "Hightouch",
          items: <FeaturesTabColumn isHightouch features={hightouchFeatures} />,
        },
        {
          label: "Traditional CDP",
          items: <FeaturesTabColumn features={traditionalFeatures} />,
        },
      ]}
    />
  );
}

function FeaturesTabColumn({ isHightouch, features }: { features: FeatureDetails[]; isHightouch?: boolean }) {
  return (
    <Flex flexDir="column" gap="bigger">
      {features.map((feature) => (
        <Flex key={feature.title} flexDir="column" gap="smallest">
          <Flex gap="tiny">
            {isHightouch ? (
              <SuccessIcon mt="tiniest" color="new.green.500" />
            ) : (
              <ErrorIcon mt="tiniest" color="new.yellow.700" />
            )}
            <Text textStyle="headline3" fontSize={{ base: "brand.sm", sm: "brand.md" }}>
              {feature.title}
            </Text>
          </Flex>
          <Text textStyle={{ base: "caption2", sm: "caption1" }}>{feature.description}</Text>
        </Flex>
      ))}
    </Flex>
  );
}
